<template>
  <div class="loader-back" unselectable="on">
    <table width="100%" height="100%">
      <tr><td width="30%" height="30%"></td><td width="30%"></td><td width="30%"></td></tr>
      <tr><td width="30%" height="30%"></td><td width="30%" align="center">
        <div class="info-loader">Загрузка...</div>
      </td><td width="30%"></td></tr>
      <tr><td width="30%" height="30%"></td><td width="30%"></td><td width="30%"></td></tr>
    </table>
  </div>
</template>

<script>
export default {
name: "LoaderWait"
}
</script>

<style scoped>
.loader-back {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.1);
}
.info-loader {
  background-color: #000;
  padding: 100px;
  font-size: 30px;
  color: #F5F5F5;
  border-radius: 30px;
}
</style>
